module.exports = __webpack_public_path__ + "img/oddvega_icon_hover.a3edb024.png";